import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { EVENT_TYPE } from '../../../../constants/index';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = makeStyles(theme => {
  return {
    '@global': {
      '.mediaWrapper': {
        minHeight: '25vh',
        background: 'black',
        position: 'relative',
        zIndex: '2',
        backgroundColor: theme.mixins.White(),
        paddingBottom: '1px',
        '& + *': {
          marginTop: pxToRem(50),
          [theme.breakpoints.up('lg')]: {
            marginTop: pxToRem(61),
          },
        },
        [theme.breakpoints.up('lg')]: {
          minHeight: '40vh',
        },
        '&.video-playing': {
          position: 'fixed',
          top: 0,
          height: '100vh',
          width: '100%',
          zIndex: 999999,
          '& .seeAllBtn': {
            display: 'none',
          },
          '& .plyr--video': {
            height: '100vh',
          },
        },
      },
    },
    root: {
      display: 'flex',
      position: 'relative',
      // marginBottom: theme.spacing(6),
      '& .grid-item': {
        width: '100%',
      },

      '& > section.MuiContainer-root': {
        width: 'auto',
      },

      '& .clickable-item': {
        position: 'relative',
        overflow: 'hidden',
        '&:before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 2,
        },
        '& .noRendition': {
          display: 'block',
        },
        '& picture': {
          height: '100%',

          '& img': {
            display: 'block',
          },
        },

        '& .playIcon': {
          position: 'absolute',
          width: pxToRem(48),
          height: pxToRem(48),
          top: '50%',
          ...theme.mixins.left('50%'),
          marginTop: pxToRem(-48 / 2),
          ...theme.mixins.marginLeft(pxToRem(-48 / 2)),
          color: theme.mixins.White(),
          borderWidth: pxToRem(2),
          borderColor: theme.mixins.White(),
          borderStyle: 'solid',
          zIndex: 9,
          padding: 0,
          [theme.breakpoints.up('lg')]: {
            width: pxToRem(109),
            height: pxToRem(109),
            ...theme.mixins.marginLeft(pxToRem(-109 / 2)),
            marginTop: pxToRem(-109 / 2),
          },
          '& svg': {
            height: pxToRem(18),
            position: 'relative',
            left: pxToRem(2),
            width: pxToRem(18),
            [theme.breakpoints.up('lg')]: {
              height: theme.spacing(5),
              width: theme.spacing(5),
            },
          },
          '&:hover': {
            background: theme.mixins.Black(500),
            transition: 'background 0.3s ease-in-out',
          },
        },
      },

      '&.singleGallery': {
        '& .seeAllBtn': {
          display: 'none',
        },
      },

      '& .singleFeatureImage': {
        '& .clickable-item': {
          '&.fallBackColor': {
            background: theme.mixins.Grey(200),
            [theme.breakpoints.down('md')]: {
              minHeight: '30vh',
              '& img': {
                minHeight: '30vh',
              },
            },
          },
        },
        [theme.breakpoints.up('lg')]: {
          '& .clickable-item': {
            '& .picture-with-play-icon': {
              height: '100%',
            },
          },
        },
      },
    },

    overlayWrapper: {
      zIndex: '1400 !important',
      '&.hidden': {
        display: 'none',
      },
      '& .slick-prev.slick-disabled,  & .slick-next.slick-disabled': {
        zIndex: '10',
      },
      '& .MuiBackdrop-root': {
        [theme.breakpoints.up('lg')]: {
          // we need important here to override inline style
          // of overlay backdrop it is blocking scroll in
          // windows machine
          opacity: '0 !important',
        },
      },
      '& .MuiDialog-paper': {
        width: '100%',
        maxWidth: '100%',
        margin: 'auto',
        transition: 'all .3s ease-in-out',

        '& .slick-slider': {
          '& .slick-next, & .slick-prev': {
            [theme.breakpoints.down('md')]: {
              top: 'auto',
              bottom: pxToRem(-100),
              '& .MuiIconButton-label': {
                position: 'relative',
              },
            },
          },
          [theme.breakpoints.down('md')]: {
            '& .slick-arrow': {
              '& .MuiSvgIcon-root': {
                width: pxToRem(16),
                height: pxToRem(16),
                top: '0',
                left: '0',
              },
            },
          },
          '& .slick-track': {
            alignItems: 'flex-start',

            [theme.breakpoints.up('lg')]: {
              '& .slick-slide': {
                visibility: 'hidden',

                '&.slick-active': {
                  visibility: 'visible',
                },
              },
            },
          },
        },

        '& .MuiDialogTitle-root, & .MuiDialogContent-root': {
          width: '100%',
          margin: 'auto',
          overflow: 'visible',
          [theme.breakpoints.up('lg')]: {
            width: '60%',
            zIndex: '10',
          },
        },

        '& .MuiDialogContent-root': {
          paddingTop: 0,
          [theme.breakpoints.down('md')]: {
            paddingBottom: pxToRem(100),
          },
          '& .slider-wrapper': {
            [theme.breakpoints.down('md')]: {
              paddingTop: 0,
              ...theme.mixins.marginLR(-24, -24),
            },
          },
          '& .plyr__poster': {
            backgroundPosition: 'top',
            backgroundSize: 'cover',
          },
        },
        '& .MuiDialogTitle-root': {
          marginTop: theme.spacing(13),
          [theme.breakpoints.up('lg')]: {
            marginTop: 0,
          },
          '& h2': {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            '& .slideCount': {
              textWrap: 'nowrap',
              marginTop: pxToRem(-30),
              color: theme.mixins.White(),
              width: '23%',
              minWidth: pxToRem(40),
              textAlign: theme.mixins.textRight,
              [theme.breakpoints.up('lg')]: {
                marginTop: pxToRem(20),
                width: '15%',
              },
            },
          },
        },
      },
      '&.video-playing': {
        '&.youku-video': {
          '& .youku-player': {
            [theme.breakpoints.down('md')]: {
              height: '100vh',
            },
          },
        },
        '& .MuiDialog-container': {
          height: 'auto',
          '& .overlayCloseBtn': {
            zIndex: 0,
          },
        },
        '& .MuiDialog-paper': {
          maxWidth: 'none',
          borderRadius: borderRadius.b0,
          '& .MuiDialogTitle-root': {
            display: 'none',
          },
          '& .MuiDialogContent-root': {
            overflow: 'hidden',
            padding: 0,
            width: '100%',

            '& .plyr--video': {
              height: '100vh',
            },

            '& .location-info, & .slick-thumb, & .slick-arrow': {
              // added important here because slick slider
              // add inline style displya block
              display: 'none !important',
            },

            '& .slider-wrapper': {
              [theme.breakpoints.down('md')]: {
                ...theme.mixins.marginLR(0, 0),
              },
            },
          },
        },
      },
    },

    '& .slick-thumb': {
      '& li': {
        width: pxToRem(107),
        height: pxToRem(104),
        overflow: 'hidden',
      },
    },

    seeAllBtn: {
      position: 'absolute',
      bottom: ({ contentType }) =>
        contentType === EVENT_TYPE ? pxToRem(56) : pxToRem(24), // This is a case for event details page
      ...theme.mixins.right(pxToRem(24)),
      background: theme.palette.common.white,
      minWidth: pxToRem(76),
      minHeight: pxToRem(32),
      borderRadius: borderRadius.b4,
      padding: '7px',
      [theme.breakpoints.up('lg')]: {
        minWidth: pxToRem(106),
        minHeight: pxToRem(46),
        bottom: pxToRem(24),
        ...theme.mixins.right(pxToRem(96)),
      },

      '& svg': {
        width: pxToRem(14),
        ...theme.mixins.marginRight(10),
      },

      '&:hover': {
        background: theme.palette.common.white,
      },

      '& .MuiButton-endIcon': {
        display: 'none',
      },
    },
  };
});
export default useStyles;
